LayoutController.$inject = []
function LayoutController(){

}

export default LayoutController